import type { ArmeniaAct } from "../../components/features/armenia/acts/ArmeniaActsHistoryDrawer";

type ArmeniaActMetadata = {
  source?: string;
  agent_pager?: string | number;
  clients?: unknown[];
};

const OFFICE_TO_PROVIDER: Record<number, string> = {
  67: "ae",
  68: "am",
  87: "za",
};

export const getArmeniaActMetadata = (
  act?: ArmeniaAct | null,
): ArmeniaActMetadata => {
  if (!act) return {};

  try {
    return typeof act.metadata === "string"
      ? JSON.parse(act.metadata || "{}")
      : (act.metadata ?? {});
  } catch {
    return {};
  }
};

export const getArmeniaActPager = (act?: ArmeniaAct | null) => {
  const metadata = getArmeniaActMetadata(act);
  return String(metadata?.agent_pager ?? "");
};

export const getArmeniaActSource = (act?: ArmeniaAct | null) => {
  const metadata = getArmeniaActMetadata(act);
  const source = String(metadata?.source ?? "")
    .trim()
    .toLowerCase();

  if (source) {
    return source;
  }

  return OFFICE_TO_PROVIDER[Number(act?.office ?? 0)] ?? "";
};

export const getArmeniaActsByAgent = ({
  acts,
  pager,
  agentTnId,
  isAdmin,
}: {
  acts: ArmeniaAct[];
  pager?: string;
  agentTnId?: string;
  isAdmin?: boolean;
}) => {
  return acts
    .filter((act) => {
      if (isAdmin) {
        return String(act.tn_id ?? "") === String(agentTnId ?? "");
      }

      return getArmeniaActPager(act) === String(pager ?? "");
    })
    .sort((a, b) => Number(b.version ?? 0) - Number(a.version ?? 0));
};
